export default "__VITE_ASSET__F1iz12zS__"